// Central content for Dr. Pranidha Shree's website

export const DOCTOR = {
  name: "Dr. Pranidha Shree C A",
  quals: "MBBS, MS, DNB, M.Ch. (Gynecologic Oncology), FMAS",
  role: "Consultant Gynecologic Oncologist",
  hospital: "SPARSH Hospital, Sarjapur Road, Bengaluru",
  phone: "8105139076",
  phoneIntl: "918105139076",
  email: "Pranidhashree@gmail.com",
  photo: "https://customer-assets-eiarnc6j.emergentagent.net/job_65a18a4f-482a-4d06-84b8-5e2b5f92ac41/artifacts/z9gk0rwf_IMG_0784.jpeg",
};

export const IMAGES = {
  heroAbstract: "https://images.unsplash.com/photo-1641488730647-954b8e96ba96?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMHdhcm0lMjBmbHVpZCUyMGN1cnZlcyUyMG1hY3JvfGVufDB8fHx8MTc4NDg2NTM0OHww&ixlib=rb-4.1.0&q=85",
  hospital: "https://images.pexels.com/photos/35215414/pexels-photo-35215414.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  lab: "https://images.pexels.com/photos/8533045/pexels-photo-8533045.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  esgoPoster: "https://customer-assets-39nsmqrw.emergentagent.net/job_pranidha-cancer-care/artifacts/rr1lz6hn_fcc6c125-0d19-46f2-8d70-7a7a0e452584.JPG",
};

export const STATS = [
  { value: "12+", label: "Years of Clinical Experience" },
  { value: "4+", label: "Years in Gynecologic Oncology" },
  { value: "AIR 80", label: "NEET-SS Super Speciality" },
  { value: "7+", label: "Peer-reviewed Publications" },
];

// ESGO / awareness ribbon colors per cancer
export const CANCERS = [
  {
    key: "ovarian",
    name: "Ovarian Cancer",
    ribbon: "#008080",
    onRibbon: "#ffffff",
    tint: "rgba(0,128,128,0.08)",
    blurb: "Often diagnosed at an advanced stage; expert cytoreductive surgery is central to outcomes.",
    risks: [
      "Age (postmenopausal women)",
      "BRCA1/BRCA2 mutations & family history",
      "Lynch syndrome",
      "Nulliparity / early menarche, late menopause",
      "Endometriosis",
    ],
    symptoms: [
      "Persistent bloating / abdominal distension",
      "Pelvic or abdominal pain",
      "Feeling full quickly / difficulty eating",
      "Urinary urgency or frequency",
      "Unexplained fatigue or weight change",
    ],
  },
  {
    key: "cervical",
    name: "Cervical Cancer",
    ribbon: "#008080",
    onRibbon: "#ffffff",
    tint: "rgba(0,128,128,0.08)",
    striped: true,
    blurb: "Largely preventable through HPV vaccination and regular screening.",
    risks: [
      "Persistent high-risk HPV infection",
      "Early sexual activity / multiple partners",
      "Smoking",
      "Immunosuppression (e.g., HIV)",
      "Lack of screening",
    ],
    symptoms: [
      "Abnormal or post-coital bleeding",
      "Bleeding between periods or after menopause",
      "Unusual vaginal discharge",
      "Pelvic pain",
      "Pain during intercourse",
    ],
  },
  {
    key: "endometrial",
    name: "Endometrial (Uterine) Cancer",
    ribbon: "#E8A87C",
    onRibbon: "#1A1C1A",
    tint: "rgba(232,168,124,0.14)",
    blurb: "The most common gynecologic cancer; early bleeding symptoms allow early diagnosis.",
    risks: [
      "Obesity & metabolic syndrome",
      "Unopposed oestrogen / PCOS",
      "Diabetes & hypertension",
      "Late menopause, nulliparity",
      "Lynch syndrome",
    ],
    symptoms: [
      "Postmenopausal bleeding (key warning sign)",
      "Heavy or irregular periods",
      "Bleeding between periods",
      "Pelvic pain or pressure",
      "Abnormal vaginal discharge",
    ],
  },
  {
    key: "sarcoma",
    name: "Uterine Sarcoma",
    ribbon: "#E8A87C",
    onRibbon: "#1A1C1A",
    tint: "rgba(232,168,124,0.14)",
    blurb: "A rare, aggressive tumour of the uterine muscle requiring specialised surgical care.",
    risks: [
      "Prior pelvic radiation",
      "Tamoxifen therapy",
      "Age (postmenopausal)",
      "Rapidly enlarging uterine mass",
    ],
    symptoms: [
      "Rapidly growing pelvic mass",
      "Abnormal uterine bleeding",
      "Pelvic pain or pressure",
      "Feeling of fullness in the abdomen",
    ],
  },
  {
    key: "vulvar",
    name: "Vulvar Cancer",
    ribbon: "#C9A0DC",
    onRibbon: "#1A1C1A",
    tint: "rgba(201,160,220,0.16)",
    blurb: "Sentinel lymph node mapping enables precise, less-morbid surgical management.",
    risks: [
      "HPV infection & VIN (pre-invasive disease)",
      "Lichen sclerosus",
      "Smoking",
      "Older age",
      "Immunosuppression",
    ],
    symptoms: [
      "Persistent vulvar itching",
      "A lump, ulcer or wart-like growth",
      "Pain, tenderness or bleeding",
      "Skin colour or thickness changes",
    ],
  },
  {
    key: "vaginal",
    name: "Vaginal Cancer",
    ribbon: "#4169E1",
    onRibbon: "#ffffff",
    tint: "rgba(65,105,225,0.10)",
    blurb: "Uncommon; treatment is individualised through a multidisciplinary team.",
    risks: [
      "Persistent HPV infection",
      "History of cervical pre-cancer / cancer",
      "In-utero DES exposure",
      "Older age, smoking",
    ],
    symptoms: [
      "Abnormal vaginal bleeding",
      "Watery or blood-stained discharge",
      "A palpable vaginal mass",
      "Pain during intercourse",
    ],
  },
  {
    key: "gtn",
    name: "Gestational Trophoblastic Neoplasia",
    ribbon: "#008080",
    onRibbon: "#ffffff",
    tint: "rgba(0,128,128,0.08)",
    blurb: "Highly curable pregnancy-related tumour when diagnosed and monitored expertly.",
    risks: [
      "Prior molar pregnancy",
      "Very young or advanced maternal age",
      "Previous GTN",
    ],
    symptoms: [
      "Irregular bleeding after pregnancy",
      "Persistently high hCG levels",
      "Enlarged uterus for dates",
      "Severe nausea / vomiting",
    ],
  },
];

export const EXPERTISE = {
  surgical: {
    title: "Advanced Surgical Expertise",
    items: [
      "Advanced Laparoscopic Gynecologic Oncology Surgery",
      "Comprehensive Surgical Staging for Gynecologic Malignancies",
      "Sentinel Lymph Node Mapping",
      "Cytoreductive (Debulking) Surgery for Ovarian Cancer",
      "Fertility-Sparing Surgery in Selected Gynecologic Cancers",
    ],
  },
  prevention: {
    title: "Prevention & Survivorship",
    items: [
      "HPV Vaccination & Cervical Cancer Prevention",
      "Colposcopy & Management of Pre-invasive Cervical Disease",
      "Hereditary Cancer Syndromes (BRCA & Lynch)",
      "Cancer Risk Assessment & Genetic Counselling",
      "Enhanced Recovery After Surgery (ERAS)",
      "Survivorship & Quality-of-Life Care",
      "Precision & Personalized Cancer Care",
    ],
  },
};

export const MANIFESTO = [
  {
    n: "01",
    title: "Compassion first",
    body: "Every woman deserves care that begins with listening. Diagnosis and treatment are approached with empathy, dignity, and patience at every step of the journey.",
  },
  {
    n: "02",
    title: "Precision in surgery",
    body: "From minimally invasive laparoscopy to sentinel node mapping and complex cytoreduction — surgical decisions are exact, evidence-led, and tailored to each patient.",
  },
  {
    n: "03",
    title: "Evidence-based always",
    body: "Treatment follows contemporary international protocols (ESGO, FIGO) and multidisciplinary consensus with medical, radiation oncology, pathology and genetics teams.",
  },
  {
    n: "04",
    title: "Beyond the operating room",
    body: "Care extends to prevention, fertility preservation where appropriate, enhanced recovery, survivorship and long-term quality of life.",
  },
];

export const PUBLICATIONS = [
  {
    title: "Mapping Lymphedema: A Prospective Study of Its Burden, Predictors, and Quality-of-Life Impact After Nodal Staging in Endometrial Cancer",
    tag: "Endometrial Cancer • Survivorship",
  },
  {
    title: "Clinicopathological Characteristics and Survival Trends in Rare Low-Grade Serous Ovarian Cancer: A Retrospective Analysis",
    tag: "Ovarian Cancer",
  },
  {
    title: "Should We Prioritise Proper Surgical Staging for Patients with Atypical Endometrial Hyperplasia (AEH)? Experience from a Single-Institution Tertiary Care Oncology Centre",
    tag: "Surgical Staging",
  },
  {
    title: "The New FIGO 2023 Staging Reclassification of Patients with FIGO 2009 Stage IVB Endometrial Cancer Correlates to Progression-Free and Overall Survival Outcomes",
    tag: "FIGO Staging",
  },
  {
    title: "Large Adnexal Mass: Is Laparoscopic Surgery a Safe Option?",
    tag: "Minimally Invasive Surgery",
  },
  {
    title: "Biochemical and Hematological Investigations in Pregnancy-Induced Hypertension",
    tag: "Obstetrics",
  },
  {
    title: "Lactate Dehydrogenase (LDH) as a Prognostic Marker in Hypertensive Disorders of Pregnancy",
    tag: "Obstetrics",
  },
];

export const JOURNALS = [
  "International Journal of Gynecological Cancer (IJGC)",
  "European Journal of Obstetrics & Gynecology and Reproductive Biology",
  "Gynecologic Oncology Reports",
  "International Journal of Reproduction, Contraception, Obstetrics and Gynecology",
  "International Journal of Clinical Obstetrics and Gynaecology",
];

export const HONORS = [
  "All India Rank 80 in NEET-SS (Super Speciality) — securing M.Ch. Gynecologic Oncology at AIMS, Kochi",
  "ESGO Certified — European Society of Gynaecological Oncology",
  "Fellow of Minimal Access Surgery (FMAS)",
  "IAPC Certified — Indian Association of Palliative Care",
  "Oral Paper & Poster Presenter at AGOICON (Association of Gynaecologic Oncologists of India)",
  "International Poster Presenter at the 27th ESGO Congress",
  "Invited speaker & educator for postgraduate teaching and CME programs",
];

export const TRAINING = [
  { place: "Amrita Institute of Medical Sciences (AIMS), Kochi", detail: "M.Ch. Gynecologic Oncology — one of India's premier tertiary cancer centres" },
  { place: "Tata Memorial Hospital, Mumbai", detail: "Clinical observership — complex oncologic surgery & multidisciplinary care" },
  { place: "Tata Medical Center, Kolkata", detail: "Clinical observership — contemporary evidence-based treatment strategies" },
];

export const REVIEWS = [
  {
    name: "Sithara Karthik",
    rating: 5,
    when: "4 days ago",
    source: "Google Review",
    image: "https://customer-assets-39nsmqrw.emergentagent.net/job_pranidha-cancer-care/artifacts/ygyekb5y_c7f2c77b-15f6-41c0-aebe-165317badddd.jpeg",
    text: "I underwent a robotic myomectomy at another hospital and was later advised I might need a hysterectomy. When I consulted Dr. Pranidha Shree, she carefully reviewed my case, repeated the biopsy at Sparsh and concluded a hysterectomy was not necessary. She is highly knowledgeable, compassionate, and explains every detail clearly. She helped me avoid an unnecessary surgery and made a significant positive difference in my life.",
  },
  {
    name: "HK Nagalakshmi",
    rating: 5,
    when: "a week ago",
    source: "SPARSH Hospital, Sarjapur Road",
    image: "https://customer-assets-39nsmqrw.emergentagent.net/job_pranidha-cancer-care/artifacts/whv5xdf5_f5816814-6d43-4ffa-8d6b-902fb4c8d829.jpeg",
    text: "Got a surgery done from Dr. Pranidha Shree. From the time of initial diagnosis, to admission, the surgery and discharge — the support and comfort was excellent. There was a very human touch to the entire journey. Not many doctors are able to retain it in the changing corporate world. Wish her success and strength.",
  },
  {
    name: "Jaideep Mahani",
    rating: 4,
    when: "2 days ago",
    source: "Google Review",
    image: "https://customer-assets-39nsmqrw.emergentagent.net/job_pranidha-cancer-care/artifacts/zx4xsj5d_181f321c-1747-4a6b-b87d-1598b5e4066b.jpeg",
    text: "My wife was admitted for removal of a cyst near the lower abdomen. Dr. Pranidha Shree did the surgery with full confidence and clarity. Surgery was successfully done and post-surgery care was taken very nicely. Whenever the doctor visited, the patient got a moral boost. She is always smiling and soft spoken. We thank Dr. Pranidha Shree from the bottom of our hearts.",
  },
];

export const CONCERNS = [
  "General Consultation",
  "Ovarian Cancer",
  "Cervical Cancer",
  "Endometrial / Uterine Cancer",
  "Vulvar Cancer",
  "Vaginal Cancer",
  "HPV Vaccination / Screening",
  "Genetic Counselling (BRCA / Lynch)",
  "Second Opinion",
  "Other",
];
